import { Box, CircularProgress } from "@mui/material";
import {
  StoreInfoSection,
  DetailSection,
  TabSection,
  BannerSection,
  FAQSection,
  RelatedCategorySection,
  RelatedStoreSection,
  StoreDetailInfoSection,
  ReservedSection,
} from "features/searchStore/sections/StoreDetail";
import { useState, useLayoutEffect, useRef } from "react";
import { useParams } from "react-router-dom";
import { storesApi } from "features/searchStore/storeApi";
import { deepJSONParse } from "helpers/convertStrToJson";
import { useDispatch } from "react-redux";
import { searchStoreActions } from "features/searchStore/saga/searchStoreSlice";
import LandscapeNavbar from "features/searchStore/components/LandscapeNavbar";

export function LandscapeView() {
  const dispatch = useDispatch();
  let { id } = useParams<{ id: string }>();
  const hashString = window.location.hash.substring(1);

  const [loading, setLoading] = useState(false);
  const sectionRef = useRef<HTMLDivElement | null>();

  useLayoutEffect(() => {
    if (!id) return;
    (async () => {
      setLoading(true);
      try {
        const data = await storesApi.getById(`${id}#${hashString}`);
        dispatch(
          searchStoreActions.setStoreDetail(deepJSONParse(data.data.body.data))
        );
        setLoading(false);
      } catch (error) {
        console.log(`Failed to fetch store details`, error);
        setLoading(false);
      }
    })();
  }, [id, hashString, dispatch]);

  return (
    <Box display="flex" flexDirection="column" width="100%">
      <Box width="100%" display="flex" justifyContent="center">
        <LandscapeNavbar />
      </Box>
      {/* Banner */}

      {loading ? (
        <Box
          display="flex"
          flexDirection="column"
          alignItems="center"
          height="100vh"
          width="100vw"
          py={10}
        >
          <CircularProgress />
        </Box>
      ) : (
        <>
          <Box width="100%">
            <BannerSection />
          </Box>

          {/* Store information */}
          <Box
            width="100%"
            display="flex"
            flexDirection="column"
            alignItems="center"
          >
            <StoreInfoSection />

            {/* Tab */}
            <TabSection sectionRef={sectionRef} />
            {/* Store detail information */}
            <DetailSection />

            <Box width="100%" ref={sectionRef}>
              <ReservedSection />
            </Box>

            <RelatedStoreSection />

            <StoreDetailInfoSection />

            <FAQSection />

            <RelatedCategorySection />
          </Box>
        </>
      )}
    </Box>
  );
}
